export const getThreadSharePath = (threadId: string) => `/share/${threadId}`;
